import { useMutation } from "@tanstack/react-query";
import { GeneratePresentationPdfResponseDto } from "../../apis/comps/presentation/generated/models/GeneratePresentationPdfResponseDto";
import { getCMAPresentationApi } from "../../apis/comps/presentation/api-factories";

type Props = {
  onSuccess?: (data: GeneratePresentationPdfResponseDto) => void;
  onError?: (error: Error) => void;
};

export type GeneratePresentationPdfParams = {
  presentationId: string;
  isAttachment?: boolean;
};

export const useGeneratePresentationPdf = (props?: Props) => {
  const { onSuccess, onError } = props || {};
  const api = getCMAPresentationApi();

  const mutation = useMutation({
    mutationFn: async (params: GeneratePresentationPdfParams) => {
      const { presentationId, isAttachment } = params;
      const response = await api.cMAPresentationControllerGeneratePdfUrl({
        id: presentationId,
        isAttachment: isAttachment ?? false,
        frontendPrintUrl: `${window.location.origin}/presentations/print`,
      });

      return response;
    },
    onError: (error) => {
      console.error("Failed to generate presentation PDF", error);
      onError?.(error as Error);
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
  });

  return mutation;
};
